export default "__VITE_ASSET__BcSK7ngL__"